import { render, staticRenderFns } from "./FirebaseUI.vue?vue&type=template&id=8612ee6e&"
import script from "./FirebaseUI.vue?vue&type=script&lang=js&"
export * from "./FirebaseUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports